import { Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { OFFER } from "@/data";
import { track } from "@/hooks/useAnalytics";

export const OfferPill = ({ testid, className = "", light = false }) => (
  <Link
    to="/offers"
    data-testid={testid}
    onClick={() => track("offer_click", { location: testid })}
    className={`group inline-flex max-w-full items-center gap-3 rounded-full ${light ? "border border-stone bg-cream" : "border border-cream/25 bg-cream/10"} py-2 pl-3 pr-4 backdrop-blur transition-[border-color,background-color] duration-300 hover:border-leaf hover:bg-leaf/20 ${className}`}
  >
    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full ${light ? "bg-forest text-cream" : "bg-cream text-forest"}`}>
      <Sparkles className="h-3.5 w-3.5" />
    </span>
    <span className={`min-w-0 font-sans text-xs leading-snug sm:text-sm ${light ? "text-ink" : "text-cream"}`}>
      <span className="font-medium">{OFFER.headline}</span>
      <span className={light ? "text-fern" : "text-mist"}> · {OFFER.sub}</span>
    </span>
  </Link>
);
